export default __webpack_public_path__ + "static/media/check-circle.5c8c8db0.svg";